import { useNavigate } from "react-router-dom";
import { Check, ArrowRight, Tag } from "lucide-react";
import { PACKS } from "@/data/content";

export const PacksSection = ({ recommended = null }) => {
  const navigate = useNavigate();

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 items-start max-w-6xl mx-auto">
      {PACKS.map((pack) => {
        const Icon = pack.icon;
        const isHighlight = pack.highlight;
        const isRecommended = recommended === pack.id;
        return (
          <div
            key={pack.id}
            data-testid={`pack-card-${pack.id.toLowerCase()}`}
            className={`relative rounded-2xl p-7 transition-all duration-300 hover:-translate-y-1 ${
              isHighlight
                ? "bg-slate-900 text-white shadow-xl ring-2 ring-green-500"
                : "bg-white text-slate-900 border border-slate-100 shadow-sm hover:shadow-md"
            }`}
          >
            {(isHighlight || isRecommended) && (
              <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-green-600 text-white text-xs font-bold uppercase tracking-wider px-4 py-1.5 rounded-full">
                {isRecommended ? "Recommandé pour vous" : "Le plus populaire"}
              </span>
            )}
            <div className={`inline-flex items-center justify-center h-12 w-12 rounded-xl mb-5 ${isHighlight ? "bg-green-600 text-white" : "bg-green-50 text-green-600"}`}>
              <Icon size={24} />
            </div>
            <h3 className="font-heading text-2xl font-bold mb-1">{pack.name}</h3>
            <p className={`text-sm font-semibold mb-4 ${isHighlight ? "text-green-400" : "text-green-600"}`}>{pack.tagline}</p>
            {pack.price && (
              <div className="mb-5">
                {pack.oldPrice ? (
                  <>
                    <span className="inline-flex items-center gap-1.5 rounded-full bg-green-600 text-white text-xs font-bold uppercase tracking-wider px-3 py-1 mb-3">
                      <Tag size={13} /> Offre de lancement
                    </span>
                    <div className="flex items-end gap-3">
                      <span className="font-heading text-4xl font-bold">{pack.price}€</span>
                      <span className="text-lg line-through mb-1 text-slate-400">{pack.oldPrice}€</span>
                    </div>
                    <p className={`text-xs mt-1 ${isHighlight ? "text-slate-400" : "text-slate-500"}`}>
                      Économisez {pack.oldPrice - pack.price}€ — durée limitée
                    </p>
                  </>
                ) : (
                  <div className="flex items-end gap-2">
                    <span className="font-heading text-4xl font-bold">{pack.price}€</span>
                  </div>
                )}
              </div>
            )}
            <p className={`mb-6 leading-relaxed ${isHighlight ? "text-slate-300" : "text-slate-600"}`}>{pack.description}</p>
            <ul className="space-y-3 mb-8">
              {pack.features.map((f, i) => (
                <li key={i} className="flex items-start gap-3">
                  <Check size={18} className={`mt-0.5 shrink-0 ${isHighlight ? "text-green-400" : "text-green-600"}`} />
                  <span className={`text-sm ${isHighlight ? "text-slate-200" : "text-slate-700"}`}>{f}</span>
                </li>
              ))}
            </ul>
            {pack.note && (
              <p className={`text-sm italic mb-6 -mt-2 ${isHighlight ? "text-slate-400" : "text-slate-500"}`}>
                {pack.note}
              </p>
            )}
            <button
              data-testid={`pack-request-${pack.id.toLowerCase()}`}
              onClick={() => navigate(`/contact?pack=${pack.id}`)}
              className={`w-full inline-flex items-center justify-center gap-2 rounded-xl px-6 py-3 font-semibold transition-colors ${
                isHighlight
                  ? "bg-green-600 hover:bg-green-700 text-white"
                  : "bg-white border-2 border-slate-200 hover:border-green-600 hover:text-green-600 text-slate-900"
              }`}
            >
              Demander ce pack <ArrowRight size={18} />
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default PacksSection;
